// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2lmFt","footer":"Form_footer__ITWKv"};